export default "__VITE_ASSET__C$jPLZgq__"